import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { PurchOrdSpDtl } from 'src/app/shared/models/PurchOrdSpDtl';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Constants } from 'src/app/shared/vo/Constants';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-purch-ord-sup-dtl',
  templateUrl: './purch-ord-sup-dtl.component.html',
  styleUrls: ['./purch-ord-sup-dtl.component.scss'],
  providers: [MessageService, ConfirmationService],
  styles: [`
        :host ::ng-deep .p-cell-editing {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        :host ::ng-deep .p-dropdown {
          width: 100%;
        }
      :host ::ng-deep .p-calendar {
        width: 100%;
      }
    `]
})
export class PurchOrdSupDtlComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  lstCols: { field: string; header: any; }[];
  filterVal: String = "all";
  clonedPurchOrdDtl : PurchOrdSpDtl[] = [];


  /** COMPONENT */

  purchOrdDtl: PurchOrdSpDtl[];
  selectedOrderLst: PurchOrdSpDtl[] = [];
  orderId: string; // IDENTIFICADOR UNICO PARA RELOAD
  purchOrdH: any;
  canEdit: boolean = false;
  selectedSupplier: any;
  ordDate: Date;
  lstCurrency: any[];
  selectedCurrency: any;
  listLanguage: ValuesVO[] = [];
  selectedLanguage: ValuesVO;

  multList: any[];
  descriptionList: any[];
  costUnitList: any[];

  tableName: string;
  dataParent: any;
  purchOrdDtlForm: FormGroup;
  blocked: boolean = true;

  /**
   * This constructor initializes various services and variables used in the component, and checks for
   * authentication based on the token and device parameters.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user.
   * @param {PurchOrdSupLstTestService} purchOrdDtlServiceTest - This parameter is an instance of the
   * PurchOrdSupLstTestService class, which is used to perform operations related to purchase order
   * details.
   * @param {ConfirmationService} confirmationService - This parameter is an instance of the
   * ConfirmationService class, which is used to display confirmation dialogs to the user.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API calls and handling responses.
   * @param {Router} router - The router is a service provided by Angular that allows you to navigate
   * between different components and routes in your application. It is used to programmatically navigate
   * to different pages or components.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route's
   * information, such as the URL parameters and query parameters. It is injected from the Angular
   * `ActivatedRoute` class.
   * @param {AuthenticationService} authenticationService - This parameter is used for authentication and
   * user management. It provides methods for logging in, logging out, and retrieving the current user.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the Tovpil application. It may include functions for formatting data, manipulating
   * strings, or performing common calculations.
   * @param {TovpilFilesService} filesService - A service that handles file-related operations, such as
   * uploading and downloading files.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService,
    private formBuilder: FormBuilder) {
    this.purchOrdDtlForm = this.formBuilder.group({
      coordinacion: [''],
      pais: [''],

      fechaRequerimientoDate: [''],
      moneda: [''],
      filtro: ['all'] // Default value for the radio buttons
    });

    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;

    this.tableName = this.getTableName();
    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  ngOnInit(): void {

    if (this.dataParent) {
      this.security = this.dataParent.security;
      this.purchOrdH = this.dataParent.purchOrdH ? this.dataParent.purchOrdH : null;
      this.selectedSupplier = this.dataParent.selectedSupplier ? this.dataParent.selectedSupplier : null;
      if (!this.selectedSupplier) {
        this.goBack();
      }
      if (this.purchOrdH) {
        this.orderId = this.purchOrdH.orderId;
        this.ordDate = this.tovpilUtils.convertStringToDate(this.purchOrdH.ordDate);
      }

    } else {
      this.goBack();
      this.currentUser = this.authenticationService.currentUserValue;
    }
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response.
   * @param {string} user - A string representing the username or user identifier.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
     * The function `getSecurity()` retrieves security data and then calls another function to get
     * translated labels.
     */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();

        });
    } else {
      this.getTranslatedLabels();

    }

  }

  /**
   * The function "loadData" loads purchase order details and sets the selected coordination based on the
   * provided data security.
   * @param {any} dataSecurity - The `dataSecurity` parameter is of type `any`, which means it can accept
   * any data type.
   */
  loadData() {
    this.blocked = true;

    let params = {
      "orderId": this.orderId,
      "language": this.selectedLanguage.valueId,
      "storeId": this.security.storeId,
      "supplierId": this.selectedSupplier.supplId
    }
    // NO SE CREARÁ
    if (this.canEdit == false) {
      this.apiService.getPurchordhOrderRequest(params).then(
        data => {
          this.purchOrdDtl = data;
          this.makeOrderDtlFormat();
          setTimeout(() => {
            this.blocked = false;
          }, 1500);
        }
      ).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Error' + error, detail: "loading data", life: 3000 });
      });
    }
  }

  loadpurchOrdDtl() {
    if (this.canEdit == false) {
      this.loadData();
    }
  }

  /**
   * This TypeScript function deletes the selected products from a list and displays a confirmation
   * message.
   */
  deleteselectedPurchOrdDtl() {
    this.confirmationService.confirm({
      message: 'Confirma eliminar registros?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.purchOrdHChgSts(Constants.CANCEL_DELETE_STATUS);
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
      }
    });
  }

  /**
   * The function `deletepurchOrdDtl` deletes a purchase order detail from a list of orders and displays
   * a confirmation message before deleting.
   * @param {PurchOrdSpDtl} order - PurchOrdSpDtl - an object representing a purchase order. It contains
   * properties such as "descripcion" (description) and "idArticulo" (article ID).
   */
  deletepurchOrdDtl(order: PurchOrdSpDtl) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ' + order.descri + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        order.ordD.appQty = 0;
        order.ordD.unitCost = 0;
        this.saveUpdatePurchOrd(order);

        this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Articulo eliminado', life: 3000 });
      }
    });
  }


  handleShowRequired() {
    if (this.filterVal == "all") {
      this.loadData();
    }
    else if (this.filterVal == "only") {
      let required = this.purchOrdDtl.filter(e =>
        e.ordD != null && e.ordD.appQty != 0
      );
      this.purchOrdDtl = required;
    }
  }


  sumRows(columna: string): number {
    if (this.purchOrdDtl != null) {
      return this.purchOrdDtl.reduce((suma, fila) => suma + fila[columna], 0);
    }
  }


  /**
   * The function onRowEditInit takes a parameter of type PurchOrdSpDtl and does nothing.
   * @param {PurchOrdSpDtl} order - The parameter "order" is of type "PurchOrdSpDtl".
   */
  onRowEditInit(order: PurchOrdSpDtl) {
    this.clonedPurchOrdDtl[order.itemId] = this.tovpilUtils.deepClone(order);
  }

  /**
   * The function updates or creates a purchase order based on the provided
   * `PurchOrdSpDtl` object.
   * @param {PurchOrdSpDtl} order - The parameter "order" is of type "PurchOrdSpDtl", which is an object
   * representing a purchase order.
   */
  saveUpdatePurchOrd(pORequestVO: any) {
    let purchOrdDVO: any;
    this.apiService.createUpdateDeletePurchordd({
      "ordH": {
        "orderId": this.orderId,
        "currency": this.selectedCurrency.valueId,
        "language": this.selectedLanguage.valueId,
        "ordDate": this.tovpilUtils.dateToTovpilDate(this.ordDate),
        "storeId": this.security.storeId,
        "status": this.purchOrdH && this.purchOrdH.status?this.purchOrdH.status:"N",
        "supplStoreId":this.selectedSupplier.storeId,
        "supplierId": this.selectedSupplier.supplId        
      },
      "ordD": {
        "id": {
          "itemId": pORequestVO.itemId,
          "orderId": this.orderId,
          "language": this.security.language
        },
        "appQty": pORequestVO?.ordD?.appQty || 0,
        "unitCost": pORequestVO?.ordD?.unitCost || 0
      },
      "language": this.security.language
    }
    ).then(
      data => {
        purchOrdDVO = data;
        if (purchOrdDVO && purchOrdDVO.status && purchOrdDVO.status == 'OK') {
          this.orderId = purchOrdDVO.ordH.orderId;
          this.purchOrdH = purchOrdDVO.ordH;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Registro actualizado', life: 500 });
          this.loadData();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: purchOrdDVO.errorMessage, life: 9000 });
        }
      });
  }

  /**
   * The function onRowEditCancel takes in an order and an index as parameters and does nothing.
   * @param {PurchOrdSpDtl} order - The order parameter is of type PurchOrdSpDtl, which represents a
   * purchase order object.
   * @param {number} index - The index parameter represents the index of the row being edited in the
   * table.
   */
  onRowEditCancel(order: PurchOrdSpDtl, index: number) {
    this.purchOrdDtl[index] = this.clonedPurchOrdDtl[order.itemId];
    delete this.clonedPurchOrdDtl[order.itemId];
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    let obj = {
      security: this.security,
      selectedSupplier: this.selectedSupplier,
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['/materials/purchOrdSupLst'], navigationExtras);
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * `getLanguages`.
   */
  async getTranslatedLabels() {
    try {
      const language = this.security.language;
      const region = this.security.region;
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.getListCurrencyByStoreId();
      this.getListSpkLangByStoreId();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
      // Error al traer labels traducidos
    }
  }


  /**
   * The exportExcel function exports a list of purchase orders to an Excel file.
   */
  exportExcel() {
    if (this.purchOrdDtl === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.purchOrdDtl.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.purchOrdDtl.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "MULT": item ? (item?.conv || 'S/N') : 'S/N',
        "CONSUMO(1_AÑO)": item ? (item?.consumption || 'S/N') : 'S/N',
        "+20%": item ? (item?.twentyPercent || 'S/N') : 'S/N',
        "Subtotal": item ? (item?.subtotal || 'S/N') : 'S/N',
        "Existencia": item ? (item?.onHand || 'S/N') : 'S/N',
        "Presupuesto": item ? (item?.budget || 'S/N') : 'S/N',
        "Cant_Requer": item ? (item?.ordD?.appQty || 'S/N') : 'S/N',
        "Costo_Uni": item ? (item?.ordD?.unitCost || 'S/N') : 'S/N',
        "Total": item ? (item?.total || 'S/N') : 'S/N',
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listPurchOrders_');

    }
  }

  /**
   * The exportPdf function exports a PDF file based on the data in the purchOrdDtl object.
   */
  exportPdf() {
    if (this.purchOrdDtl === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.purchOrdDtl.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.purchOrdDtl.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "MULT": item ? (item?.conv || 'S/N') : 'S/N',
        "CONSUMO(1_AÑO)": item ? (item?.consumption || 'S/N') : 'S/N',
        "+20%": item ? (item?.twentyPercent || 'S/N') : 'S/N',
        "Subtotal": item ? (item?.subtotal || 'S/N') : 'S/N',
        "Existencia": item ? (item?.onHand || 'S/N') : 'S/N',
        "Presupuesto": item ? (item?.budget || 'S/N') : 'S/N',
        "Cant_Requer": item ? (item?.ordD?.appQty || 'S/N') : 'S/N',
        "Costo_Uni": item ? (item?.ordD?.unitCost || 'S/N') : 'S/N',
        "Total": item ? (item?.total || 'S/N') : 'S/N',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listPurchOrders_');

    }
  }

  /**
   * The function `getTableName` returns a formatted filename based on the current date.
   * @returns a string that represents the name of a table. The table name is generated based on the
   * current date in the format "listPurchOrders_yyyymmdd", where "yyyymmdd" represents the year, month,
   * and day of the current date. The table name is enclosed in double quotes.
   */
  getTableName() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    const filename = 'listPurchOrders_' + `${formattedDate}`;

    return `"${filename}"`;
  }


  /**
   * The `formatDate` function takes an input date and returns it in the format "YYYYMMDD".
   * @param inputDate - The inputDate parameter is the date that you want to format. It should be a valid
   * date string that can be parsed by the Date constructor.
   * @returns a formatted date string in the format "YYYYMMDD".
   */
  formatDate(inputDate) {
    const originalDate = new Date(inputDate);
    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

  /**
   * The function "makeOrderDtlFormat" formats various properties of the "purchOrdDtl" object, including
   * calculating percentages and totals, formatting dates, and creating filtered lists based on certain
   * properties.
   */
  makeOrderDtlFormat() {


    if (this.purchOrdDtl) {
      this.purchOrdDtl.forEach(ord => {
        ord.consumption = (ord?.sales != null || ord?.returns != null) ? parseFloat((ord.sales - ord.returns).toFixed(2)) : 0;
        ord.twentyPercent = (ord?.sales != null || ord?.returns != null) ? parseFloat(((ord.sales - ord.returns) * 0.2).toFixed(2)) : 0;
        ord.subtotal = (ord?.consumption != null || ord?.twentyPercent != null) ? parseFloat((ord.consumption + ord.twentyPercent).toFixed(2)) : 0;
        ord.budget = (ord?.subtotal != null || ord?.onHand != null) ? parseFloat((ord.subtotal - ord.onHand).toFixed(2)) : 0;
        ord.total = (ord?.ordD?.unitCost != null && ord?.ordD?.appQty != null) ? parseFloat((ord.ordD.unitCost * ord.ordD.appQty).toFixed(2)) : 0;
      });
    }


    if (this.purchOrdDtl) {
      this.multList = this.purchOrdDtl
        .filter(item => item && item.conv !== null && item.conv !== undefined)
        .map(item => ({ label: item.conv, value: item.conv }))
        .filter((status, index, self) => self.findIndex(s => s.label === status.label) === index);

      console.log(this.multList)
      this.descriptionList = this.purchOrdDtl
        .filter(item => item && item.descri !== null && item.descri !== undefined)
        .map(item => ({ label: item.descri.trim().toUpperCase(), value: item.descri.trim().toUpperCase() }))
        .filter((status, index, self) => self.findIndex(s => s.label === status.label) === index);

      this.costUnitList = this.purchOrdDtl
        .filter(item => item.ordD && item.ordD.unitCost !== null && item.ordD.unitCost !== undefined)
        .map(item => ({ label: item.ordD.unitCost, value: item.ordD.unitCost }))
        .filter((name, index, self) =>
          self.findIndex(s => s.label === name.label && s.value === name.value) === index
        );
    }
  }
  getListCurrencyByStoreId() {
    this.apiService.getListCurrencyByStoreId({
      "storeId": this.security.storeId,
      "language": this.security.language
    }
    ).then(
      data => {
        this.lstCurrency = data;
        if (this.purchOrdH) {
          this.selectedCurrency = this.lstCurrency.find(s => s.valueId === this.purchOrdH.currency);
        }
      });
  }
  getListSpkLangByStoreId() {
    this.selectedLanguage = {};
    this.apiService.getListSpkLangByStoreId({
      "language": this.security.language,
      "storeId": this.security.storeId
    }).then(
      data => {
        this.listLanguage = data;



        if (this.purchOrdH) {
          this.selectedLanguage = this.listLanguage.find(s => s.valueId === this.purchOrdH.language);
        }
        if (!this.selectedLanguage.value) {
          this.selectedLanguage = this.listLanguage[0];
        }
        this.loadData();
      });
  }
  approve() {
    this.purchOrdHChgSts('A');
  }
  returnToNew() {
    this.purchOrdHChgSts('N');
  }
  purchOrdHChgSts(newStatus: String) {
    this.apiService.purchOrdHChgSts({
      "orderId": this.orderId,
      "status": newStatus
    }).then(
      data => {
        this.goBack();
      });
  }
  approveToInvent() {
    this.confirmationService.confirm({
      message: '¿ ' + this.translations.lbl_are_you_sure + ' ' + 'Actualizar inventario' + ' ?',
      header: this.translations.lbl_confirm + ' ' + ' Acualizar inventario',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.updateInventory();
      }
    });
  }
  updateInventory() {
    this.apiService.updatePurchordhOrderInventory({
      "orderId": this.orderId,
      "language": this.security.language,
      "userId": this.security.userId
    }).then(
      data => {
        if (data && data.status && (data.status == Constants.EXCEPTION_ERROR || data.status == Constants.ERRORSTATUS)) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
        } else {
          this.goBack();
        }
      });
  }
}
